import { useQuery } from '@tanstack/react-query';
import lendingService from 'commons/services/lending/lendingService';

export function useCreditOffer() {
  return useQuery({
    queryKey: ['creditOffer'],
    queryFn: () => lendingService.getCreditOffer(),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
